// projects/humanresources-personnel/src/assets/i18n/*/hr-per-movement-st-mandatory-fields.json
export class HrPerMovementStMandatoryFieldsKey {
    private static readonly keyPrefix = 'hrPerMovementStMandatoryFields';
    public static title = `${HrPerMovementStMandatoryFieldsKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerMovementStMandatoryFieldsKey.keyPrefix}.pageHeader`;
    public static suspensionDateField = `${HrPerMovementStMandatoryFieldsKey.keyPrefix}.suspensionDateField`;
    public static mandatoryFieldTypeEnum = `${HrPerMovementStMandatoryFieldsKey.keyPrefix}.mandatoryFieldTypeEnum`;
}
